/**
 * Configuraciones de tema por comercio (hardcodeado)
 * Cada comercio tiene su propia configuración de colores y logo
 */

export interface CommerceThemeConfig {
  id: number;
  name: string;
  primary_color: string;
  secondary_color: string;
  tertiary_color: string;
  logo_url: string;
}

export const commerceThemes: Record<number, CommerceThemeConfig> = {
  1: {
    id: 1,
    name: "Clínica Alhama",
    primary_color: "#98acae",
    secondary_color: "#a1ab9f",
    tertiary_color: "#120309",
    logo_url: "/logo.png",
  },
  // Añade aquí las configuraciones de otros comercios
  2: {
    id: 2,
    name: "Comercio 2",
    primary_color: "#4bbbbc",
    secondary_color: "#91c9b2",
    tertiary_color: "#91c9b2",
    logo_url: "/logo.png",
  },
};

/**
 * Obtiene la configuración de tema para un comercio específico
 * Si no existe configuración, usa la del comercio 1 como fallback
 */
export const getCommerceThemeConfig = (commerceId: number): CommerceThemeConfig => {
  return commerceThemes[commerceId] || commerceThemes[1];
};
